// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";

var availableBlocks = {};

function registerBlock(descriptor) {
  var blockVersion = descriptor.meta.version.toString();
  var registeredBlock = availableBlocks[descriptor.code];
  if (registeredBlock !== undefined) {
    var block = Caml_option.valFromOption(registeredBlock);
    var specificBlockVersion = block[blockVersion];
    if (Core__Option.isSome(specificBlockVersion)) {
      console.warn("Block with code " + descriptor.code + " and version " + blockVersion + " is already registered.");
    } else {
      block[blockVersion] = descriptor;
    }
    return ;
  }
  availableBlocks[descriptor.code] = Object.fromEntries([[
          blockVersion,
          descriptor
        ]]);
}

function getBlock(code, version) {
  return Core__Option.flatMap(availableBlocks[code], (function (block) {
                return block[version.toString()];
              }));
}

export {
  registerBlock ,
  getBlock ,
}
/* No side effect */
